module.exports = __webpack_public_path__ + "media/images/bg-09942b655a55b072484170bd9fe67134.jpeg";